import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActionCreators } from 'features/professional-step/+state/professional-step.actions';
import { RouteParams, Selectors as RouterSelectors } from 'features/router-state/+state/router-state.state';
import { take, withLatestFrom } from 'rxjs/operators';
import _get from 'lodash-es/get';
import _size from 'lodash-es/size';
import { PROFESSIONAL_PAGE_TITLE, WORKFLOW_MODULE_ID } from 'constants/workflow.constants';
import {
  LabelSettingRow,
  OrganizationsLabelType,
} from 'features/global-organizations-setting-state/global-organizations-setting.constant';
import { Selectors as ProfileSelectors } from 'features/profiles-state/+state/profiles-state.state';
import { UserProfile } from 'services/user/user.interface';

@Component({
  selector: 'cm-back-to-certifications-btn',
  templateUrl: './back-to-certifications-btn.component.html',
  styleUrls: ['./back-to-certifications-btn.component.scss'],
})
export class BackToCertificationsBtnComponent implements OnInit {
  title: string = PROFESSIONAL_PAGE_TITLE.DEFAULT;
  currentProfile: UserProfile;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.store
      .select(RouterSelectors.getActivatedRouterParams)
      .pipe(
        take(1),
        withLatestFrom(this.store.select(ProfileSelectors.currentProfile)),
      )
      .subscribe(([params, profile]: [RouteParams, UserProfile]) => {
        this.setTitle(+_get(params, 'workflowTypeId'), profile);
      });
  }

  private setTitle(workflowTypeId: number, profile: UserProfile) {
    if (!_size(profile.labels)) {
      return;
    }
    switch (workflowTypeId) {
      // Use TW label
      case WORKFLOW_MODULE_ID.TESTING_WORKFLOW:
        const testingProfLabel = this.getLabelFromArr(profile.labels, OrganizationsLabelType.MODULE_TESTING_PROF);
        if (!testingProfLabel) {
          return;
        }
        this.title = testingProfLabel.organizationLabel;
        break;
      // Use Credentials or Compliance label
      default:
        const credentialingProfLabel = this.getLabelFromArr(
          profile.labels,
          OrganizationsLabelType.MODULE_CREDENTIALING_PROF,
        );
        const complianceProfLabel = this.getLabelFromArr(profile.labels, OrganizationsLabelType.MODULE_COMPLIANCE_PROF);
        if (!credentialingProfLabel && !complianceProfLabel) {
          return;
        }
        this.title = credentialingProfLabel
          ? credentialingProfLabel.organizationLabel
          : complianceProfLabel.organizationLabel;
        break;
    }
  }

  private getLabelFromArr(labels: LabelSettingRow[], labelTypeId: OrganizationsLabelType): LabelSettingRow {
    return labels.find(({ labelTypeId: itemLabelTypeId }) => itemLabelTypeId === labelTypeId);
  }

  back() {
    this.store.dispatch(new ActionCreators.BackToCertifications());
  }
}
